package com.downdogapp.client.views.start

import com.downdogapp.*
import com.downdogapp.AlignItems.CENTER
import com.downdogapp.AlignItems.FLEX_START
import com.downdogapp.BoxSizing.BORDER_BOX
import com.downdogapp.JustifyContent.FLEX_END
import com.downdogapp.JustifyContent.SPACE_BETWEEN
import com.downdogapp.Position.RELATIVE
import com.downdogapp.Size.Companion.percent
import com.downdogapp.Size.Companion.px
import com.downdogapp.client.*
import com.downdogapp.client.controllers.start.HistoryPage
import com.downdogapp.client.resources.Images
import com.downdogapp.client.singleton.App
import com.downdogapp.client.singleton.HistoryUtil.favorite
import com.downdogapp.client.singleton.HistoryUtil.name
import com.downdogapp.client.widget.*
import com.downdogapp.client.widget.CustomRow.Companion.customRow
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLSpanElement

actual class HistoryPageView : AbstractView(), View {

  private var table: TableView
  private var titleLabel: HTMLSpanElement
  private var favoritesToggle: TogglePill
  private var noHistoryLabel: HTMLSpanElement

  override val root = createDiv {
    position = RELATIVE
    titleLabel = startPageTitle()

    startPageContent {
      horizontalFlexBox(horizontalJustify = FLEX_END) {
        defaultPadding()
        favoritesToggle = togglePill(
          lazyLeftText = { Strings.ALL },
          lazyRightText = { Strings.FAVORITES },
          getValue = { HistoryPage.displayFavorites },
          onValueChanged = { HistoryPage.displayFavorites = it }
        )
      }
      noHistoryLabel = label(null, 14, textAlign = TextAlign.CENTER) {
        width = percent(100)
      }
      table = tableView(::getContents)
    }
  }

  actual fun refreshView() {
    titleLabel.text = HistoryPage.title
    table.refreshContents()
    favoritesToggle.refresh()

    HistoryPage.noHistoryText?.let {
      noHistoryLabel.text = it
      noHistoryLabel.show()
    } ?: run {
      noHistoryLabel.hide()
    }
  }

  private fun getContents() = TableContents(
    rows = HistoryPage.displayItems.map { item ->
      practiceRow(
        primaryText = item.primaryText,
        secondaryText = item.name,
        iconInit = {
          if (item.appType != App.appType) {
            imageView(item.appType.badgeIcon)
          } else if (item.favorite) {
            imageView(Images.HEART_BADGE)
          }
        },
        onCellTap = {
          HistoryPage.onItemClicked(item)
        }
      )
    }
  )

  companion object {

    fun HTMLDivElement.defaultPadding() {
      paddingVertical = px(6)
      paddingHorizontal = HORIZONTAL_CONTENT_GUTTER_PX
      boxSizing = BORDER_BOX
    }

    // Used in HistoryPage and SavedPracticesPage
    fun practiceRow(primaryText: String,
                    secondaryText: String?,
                    iconInit: HTMLDivElement.() -> Unit,
                    onCellTap: () -> Unit): TableRowInit =
      customRow(px(90)) {
        root.apply {
          defaultPadding()

          horizontalFlexBox(horizontalJustify = SPACE_BETWEEN, verticalAlign = CENTER) {
            bgColor = Color.grey(0.15)
            borderRadius = px(10)
            height = percent(100)
            width = percent(100)

            verticalFlexBox(horizontalAlign = FLEX_START) {
              marginLeft = px(20)

              label(primaryText, 14, FontWeight.SEMIBOLD)

              secondaryText?.let {
                label(secondaryText, 14, FontWeight.MEDIUM) {
                  marginTop = px(3)
                }
              }
            }

            div {
              marginRight = HORIZONTAL_CONTENT_GUTTER_PX
              iconInit()
            }
          }
          onClick {
            onCellTap()
          }
        }
      }
  }
}
